import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { CustomMultiSelectModel } from "../../../components/CustomMultiSelect";
import { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { Helpers } from "../../../helpers/Helpers";
import { AddConstantResponse } from "../../../models/response/constant/AddConstantResponse";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import { ConstantService } from "../../../services/ConstantService";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import toast from "react-hot-toast";
import { GetConstantListResponse, GetConstantListResponseItem } from "../../../models/response/constant/GetConstantListResponse";
import { VehicleService } from "../../../services/VehicleService";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AddVehicleResponse } from "../../../models/response/vehicle/AddVehicleResponse";
import { GetVehicleByIdResponse, GetVehicleByIdResponseFileArchive, GetVehicleByIdResponsePeriodicalDocument, GetVehicleByIdResponseVehiclePassCard } from "../../../models/response/vehicle/GetVehicleByIdResponse";
import GeneralInformation from "./Components/GeneralInformation";
import { AddVehicleRequest } from "../../../models/request/vehicle/AddVehicleRequest";
import TechnicalInformation from "./Components/TechnicalInformation";
import PassCards from "./Components/PassCards";
import LicenseHolder from "./Components/LicenseHolder";
import RentInformation from "./Components/RentInformation";
import SaleInformation from "./Components/SaleInformation";
import PeriodicalDocuments from "./Components/PeriodicalDocuments";
import FileArchives from "./Components/FileArchives";
import Policeler from "./Components/Policeler";
import PageHeader from "../../../components/PageHeader";
import { CountryService } from "../../../services/CountryService";
import { GetCountryListResponse, GetCountryListResponseData } from "../../../models/response/country/GetCountryListResponse";
import { AracQrKodu } from "../../../services/VehicleService";
import QrKarti from "../../../components/QrEtiket/QrKarti";

const VehicleAdd = () => {
    const navigate = useNavigate();
    const pageName = "Genel Tanımlamalar > Araç Tanımları"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const generalInformationRef: any = useRef();
    const licenseHolderRef: any = useRef();
    const technicalInformationRef: any = useRef();
    const passCardsRef: any = useRef();
    const rentInformationRef: any = useRef();
    const saleInformationRef: any = useRef();
    const periodicalDocumentsRef: any = useRef();
    const fileArchivesRef: any = useRef();

    const [vehicleId, setVehicleId] = useState<string | undefined>(undefined);

    // GENEL BİLGİLER
    const [plate, setPlate] = useState('');
    const [hgsEtiketNo, setHgsEtiketNo] = useState<string | undefined>(undefined);
    const [uttsNo, setUttsNo] = useState<string | undefined>(undefined);
    const [selectedVehicleStatus, setSelectedVehicleStatus] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedVehicleType, setSelectedVehicleType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedVehicleType2, setSelectedVehicleType2] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedVehicleOwnerCompany, setSelectedVehicleOwnerCompany] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedDriver, setSelectedDriver] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedVehicleProperties, setSelectedVehicleProperties] = useState<CustomMultiSelectModel[]>([]);
    const [selectedFuelType, setSelectedFuelType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedVehicleArea, setSelectedVehicleArea] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedVehicleArea2, setSelectedVehicleArea2] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedTrailer, setSelectedTrailer] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [fuelConsumed, setFuelConsumed] = useState<string | undefined>(undefined);
    const [fuelCapacity, setFuelCapacity] = useState<string | undefined>(undefined);
    const [isBlocked, setIsBlocked] = useState(false);
    const [blockedDesc, setBlockedDesc] = useState<string | undefined>(undefined);
    const [isCustomActive, setIsCustomActive] = useState(true);
    const fileRef: any = useRef();
    const [vehicleTypeList2, setVehicleTypeList2] = useState<GetConstantListResponseItem[]>([]);
    const [file, setFile] = useState<File | undefined>(undefined);
    const [b64, setB64] = useState(Helpers.getPlaceholder());

    // RUHSAT BİLGİLERİ
    const [selectedLicenseHolder, setSelectedLicenseHolder] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedCounty, setSelectedCounty] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [documentSerialNumber, setDocumentSerialNumber] = useState<string | undefined>(undefined);
    const [registrationDate, setRegistrationDate] = useState<string | undefined>(undefined);
    const [tckn, setTckn] = useState<string | undefined>(undefined);
    const [selectedDistrict, setSelectedDistrict] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedVehicleClass, setSelectedVehicleClass] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [modelYear, setModelYear] = useState<string | undefined>(undefined);
    const [selectedVehicleColor, setSelectedVehicleColor] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [engineNumber, setEngineNumber] = useState<string | undefined>(undefined);
    const [pledgeStartDate, setPledgeStartDate] = useState<string | undefined>(undefined);
    const [pledgeEndDate, setPledgeEndDate] = useState<string | undefined>(undefined);
    const [licenseB64, setLicenseB64] = useState(Helpers.getPlaceholder());
    const licenseFileRef: any = useRef();
    const [licenseFile, setLicenseFile] = useState<File | undefined>(undefined);
    const [insuranceCode, setInsuranceCode] = useState<string | undefined>(undefined);
    const [selectedVehicleBrand, setSelectedVehicleBrand] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedVehicleBrandDetail, setSelectedVehicleBrandDetail] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [chassisNumber, setChassisNumber] = useState<string | undefined>(undefined);
    const [isDeprivationOfRights, setIsDeprivationOfRights] = useState<boolean | undefined>(undefined);
    const [selectedRightsOwner, setSelectedRightsOwner] = useState<CustomSingleSelectModel | undefined>(undefined);

    // TEKNİK BİLGİLERİ
    const [netWeight, setNetWeight] = useState<string | undefined>(undefined);
    const [width, setWidth] = useState<string | undefined>(undefined);
    const [volume, setVolume] = useState<string | undefined>(undefined);
    const [desi, setDesi] = useState<string | undefined>(undefined);
    const [loadedWeight, setLoadedWeight] = useState<string | undefined>(undefined);
    const [height, setHeight] = useState<string | undefined>(undefined);
    const [gearboxType, setGearboxType] = useState<boolean | undefined>(undefined);
    const [tacometerType, setTacometerType] = useState<boolean | undefined>(undefined);
    const [aksCount, setAksCount] = useState<string | undefined>(undefined);
    const [height2, setHeight2] = useState<string | undefined>(undefined);

    // ARAÇ GEÇİŞ KARTLARI
    const [vehiclePassCards, setVehiclePassCards] = useState<GetVehicleByIdResponseVehiclePassCard[]>([]);

    // KİRALAMA BİLGİLERİ
    const [selectedRentCompany, setSelectedRentCompany] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [rentPriceMonthly, setRentPriceMonthly] = useState<string | undefined>(undefined);
    const [selectedRentCurrency, setSelectedRentCurrency] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [rentStartDate, setRentStartDate] = useState<string | undefined>(undefined);
    const [rentEndDate, setRentEndDate] = useState<string | undefined>(undefined);
    const [rentDesc, setRentDesc] = useState<string | undefined>(undefined);

    // SATIŞ BİLGİLERİ
    const [selectedSaleCompany, setSelectedSaleCompany] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [saleTcknVkn, setSaleTcknVkn] = useState<string | undefined>(undefined);
    const [salePrice, setSalePrice] = useState<string | undefined>(undefined);
    const [selectedSaleCurrency, setSelectedSaleCurrency] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [saleProxyPersonName, setSaleProxyPersonName] = useState<string | undefined>(undefined);
    const [saleProxyStartDate, setSaleProxyStartDate] = useState<string | undefined>(undefined);
    const [saleProxyEndDate, setSaleProxyEndDate] = useState<string | undefined>(undefined);
    const [saleDesc, setSaleDesc] = useState<string | undefined>(undefined);

    // SÜRELİ BELGELER
    const [periodicalDocuments, setPeriodicalDocuments] = useState<GetVehicleByIdResponsePeriodicalDocument[]>([]);

    // DOSYA ARŞİV
    const [fileArchives, setFileArchives] = useState<GetVehicleByIdResponseFileArchive[]>([]);

    const [trCountry, setTrCountry] = useState<GetCountryListResponseData | undefined>(undefined);

    // ARAÇ QR (11.10.2026): şoför araçtaki QR'ı okutur; bilgi amaçlı (konum + süre).
    const [aracQr, setAracQr] = useState<AracQrKodu | undefined>(undefined);

    useEffect(() => {
        if (vehicleId)
            getAracQr(vehicleId);
    }, [vehicleId])

    const getAracQr = async (_vehicleId: string) => {
        try {
            var response = await VehicleService.qrKodlari([_vehicleId]);

            if (!response.isSuccess) {
                toast.error(response.message ?? '')
                return;
            }

            setAracQr(response.data.length > 0 ? response.data[0] : undefined);
        } catch (error: any) {
            console.log('Araç QR alınamadı', error);
        }
    }

    const aracQrYenile = async () => {
        if (!vehicleId)
            return;

        try {
            dispatch(storeActivityIndicator(true))

            var response = await VehicleService.qrYenile(vehicleId);

            if (!response.isSuccess) {
                toast.error(response.message ?? '')
                return;
            }

            setAracQr(response.data);
            toast.success('QR yenilendi. Yeni etiketi yazdırıp eskisinin yerine yapıştırın.');
        } catch (error: any) {
            toast.error(error)
        } finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const handleFileRead = async (event: any, setFunction: React.Dispatch<React.SetStateAction<string>>) => {
        try {
            const file = event.target.files[0]
            const base64: any = await convertBase64(file)
            setFunction(base64);
        } catch (error) {
            setFunction(Helpers.getPlaceholder())
        }
    }

    const convertBase64 = (file: any) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file)
            fileReader.onload = () => {
                resolve(fileReader.result);
            }
            fileReader.onerror = (error) => {
                reject(error);
            }
        })
    }

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var response3: GetConstantListResponse = await ConstantService.getConstantList('VEHICLE_TYPE');

            if (!response3.isSuccess) {
                toast.error(response3.message)
                return;
            }

            setVehicleTypeList2(response3.data.filter(x => x.additionalValue2 && !Helpers.isEmpty(x.additionalValue2) && x.additionalValue2 != Helpers.getPlaceholder()));

            var response2: GetCountryListResponse = await CountryService.getCountryList('TR');

            if (!response2.isSuccess) {
                toast.error(response2.message)
                return;
            }

            setTrCountry(response2.data.length > 0 ? response2.data[0] : undefined)

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response: GetVehicleByIdResponse = await VehicleService.getVehicleById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setVehicleId(response.data.vehicleId);
                setPlate(response.data.plate);
                setHgsEtiketNo(response.data.hgsEtiketNo ?? undefined);
                setUttsNo(response.data.uttsNo ?? undefined);

                if (response.data.vehicleStatusId)
                    setSelectedVehicleStatus({ label: response.data.vehicleStatusName, value: response.data.vehicleStatusId });

                if (response.data.vehicleTypeId)
                    setSelectedVehicleType({ label: response.data.vehicleTypeName, value: response.data.vehicleTypeId, additionalValue1: response.data.vehicleTypeKey });

                if (response.data.vehicleType2Id)
                    setSelectedVehicleType2({ label: response.data.vehicleType2Name, value: response.data.vehicleType2Id });

                if (response.data.vehicleOwnerId)
                    setSelectedVehicleOwnerCompany({ label: response.data.vehicleOwnerName, value: response.data.vehicleOwnerId });

                if (response.data.driverId)
                    setSelectedDriver({ label: response.data.driverName, value: response.data.driverId });

                if (response.data.fuelTypeId)
                    setSelectedFuelType({ label: response.data.fuelTypeName, value: response.data.fuelTypeId });

                if (response.data.vehicleAreaId)
                    setSelectedVehicleArea({ label: response.data.vehicleAreaName, value: response.data.vehicleAreaId });

                if (response.data.vehicleArea2Id)
                    setSelectedVehicleArea2({ label: response.data.vehicleArea2Name, value: response.data.vehicleArea2Id });

                if (response.data.trailerId)
                    setSelectedTrailer({ label: response.data.trailerName, value: response.data.trailerId });

                setFuelConsumed(response.data.fuelConsumed?.toString());
                setFuelCapacity(response.data.fuelCapacity?.toString());
                setIsBlocked(response.data.isBlocked);
                setBlockedDesc(response.data.blockedDescription);
                setIsCustomActive(response.data.isCustomActive);
                setB64(Helpers.isEmpty(response.data.image) ? Helpers.getPlaceholder() : response.data.image)

                if (response.data.vehicleProperties)
                    setSelectedVehicleProperties(response.data.vehicleProperties)

                if (response.data.licenseHolderCompanyId)
                    setSelectedLicenseHolder({ label: response.data.licenseHolderCompanyName, value: response.data.licenseHolderCompanyId });

                setDocumentSerialNumber(response.data.documentSerialNumber)
                setRegistrationDate(response.data.registrationDate);

                if (response.data.brandId) {
                    setSelectedVehicleBrand({ label: response.data.brandName, value: response.data.brandId });

                    if (response.data.brandDetailId)
                        setSelectedVehicleBrandDetail({ label: response.data.brandDetailName, value: response.data.brandDetailId })
                }

                if (response.data.brandInsuranceNumber && response.data.brandDetailInsuranceNumber)
                    setInsuranceCode(response.data.brandInsuranceNumber + " - " + response.data.brandDetailInsuranceNumber);

                setChassisNumber(response.data.chassisNumber);
                setIsDeprivationOfRights(response.data.isDeprivationOfRights);

                if (response.data.rightsOwnerId)
                    setSelectedRightsOwner({ label: response.data.rightsOwnerName, value: response.data.rightsOwnerId });

                setTckn(response.data.tcknVkn);

                if (response.data.countyId) {
                    setSelectedCounty({ label: response.data.countyName, value: response.data.countyId });

                    if (response.data.districtId) {
                        setSelectedDistrict({ label: response.data.districtName, value: response.data.districtId });
                    }
                }

                if (response.data.vehicleClassId)
                    setSelectedVehicleClass({ label: response.data.vehicleClassName, value: response.data.vehicleClassId });

                setModelYear(response.data.modelYear?.toString())

                if (response.data.vehicleColorId)
                    setSelectedVehicleColor({ label: response.data.vehicleColorName, value: response.data.vehicleColorId });

                setEngineNumber(response.data.engineNumber);
                setPledgeStartDate(response.data.pledgeStartDate);
                setPledgeEndDate(response.data.pledgeEndDate);
                setLicenseB64(Helpers.isEmpty(response.data.licenseImage) ? Helpers.getPlaceholder() : response.data.licenseImage)

                setNetWeight(response.data.netWeight?.toString());
                setWidth(response.data.width?.toString());
                setVolume(response.data.volume?.toString())
                setDesi(response.data.desi?.toString());
                setLoadedWeight(response.data.loadedWeight?.toString());
                setHeight(response.data.height?.toString());
                setGearboxType(response.data.gearboxType);
                setTacometerType(response.data.tacometerType);
                setAksCount(response.data.aksCount?.toString())
                setHeight2(response.data.height2?.toString());
                setVehiclePassCards(response.data.vehiclePassCards);

                if (response.data.rentCompanyId)
                    setSelectedRentCompany({ label: response.data.rentCompanyName, value: response.data.rentCompanyId });

                setRentPriceMonthly(response.data.rentPriceMonthly?.toString());

                if (response.data.rentCurrencyId)
                    setSelectedRentCurrency({ label: response.data.rentCurrencyName, value: response.data.rentCurrencyId });

                setRentStartDate(response.data.rentStartDate);
                setRentEndDate(response.data.rentEndDate);
                setRentDesc(response.data.rentDescription);

                if (response.data.saleCompanyId)
                    setSelectedSaleCompany({ label: response.data.saleCompanyName, value: response.data.saleCompanyId });

                setSaleTcknVkn(response.data.saleTcknVkn);
                setSalePrice(response.data.salePrice?.toString());

                if (response.data.saleCurrencyId)
                    setSelectedSaleCurrency({ label: response.data.saleCurrencyName, value: response.data.saleCurrencyId });

                setSaleProxyPersonName(response.data.saleProxyPersonName);
                setSaleProxyStartDate(response.data.saleProxyStartDate);
                setSaleProxyEndDate(response.data.saleProxyEndDate);
                setSaleDesc(response.data.saleDescription);

                setPeriodicalDocuments(response.data.periodicalDocuments);

                setFileArchives(response.data.fileArchives);
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const saveVehicle = async () => {
        try {
            if (Helpers.isEmpty(plate))
                toast.error('Plaka alanını doldurunuz!')
            else if (Helpers.isEmpty(selectedVehicleStatus))
                toast.error('Araç Durumu alanını doldurunuz!')
            else if (Helpers.isEmpty(selectedVehicleType))
                toast.error('Araç Cinsi alanını doldurunuz!')
            else if (Helpers.isEmpty(selectedVehicleOwnerCompany))
                toast.error('Araç Sahibi alanını doldurunuz!')
            else {
                dispatch(storeActivityIndicator(true));

                var obj: AddVehicleRequest = {
                    vehicleId: vehicleId,
                    plate: plate,
                    hgsEtiketNo: hgsEtiketNo,
                    uttsNo: uttsNo,
                    vehicleStatusId: selectedVehicleStatus?.value,
                    vehicleTypeId: selectedVehicleType?.value,
                    vehicleType2Id: selectedVehicleType2?.value,
                    vehicleAreaId: selectedVehicleArea?.value,
                    vehicleArea2Id: selectedVehicleArea2?.value,
                    vehicleOwnerId: selectedVehicleOwnerCompany?.value,
                    driverId: selectedDriver?.value,
                    fuelTypeId: selectedFuelType?.value,
                    trailerId: selectedTrailer?.value,
                    fuelConsumed: fuelConsumed,
                    fuelCapacity: fuelCapacity,
                    isBlocked: isBlocked ? 1 : 0,
                    blockedDescription: blockedDesc,
                    isCustomActive: isCustomActive ? 1 : 0,
                    image: file,
                    imageUrl: (b64.startsWith("http") ? b64 : undefined),
                    licenseImage: licenseFile,
                    licenseImageUrl: (licenseB64.startsWith("http") ? licenseB64 : undefined),
                    vehiclePropertyIds: selectedVehicleProperties.map(x => x.value).join(","),
                    aksCount: aksCount,
                    desi: desi,
                    gearboxType: gearboxType === undefined ? undefined : gearboxType ? 1 : 0,
                    height: height,
                    height2: height2,
                    loadedWeight: loadedWeight,
                    netWeight: netWeight,
                    tacometerType: tacometerType === undefined ? undefined : tacometerType ? 1 : 0,
                    volume: volume,
                    width: width,
                    brandDetailId: selectedVehicleBrandDetail?.value,
                    chassisNumber: chassisNumber,
                    districtId: selectedDistrict?.value,
                    documentSerialNumber: documentSerialNumber,
                    engineNumber: engineNumber,
                    isDeprivationOfRights: isDeprivationOfRights === undefined ? undefined : isDeprivationOfRights ? 1 : 0,
                    licenseHolderCompanyId: selectedLicenseHolder?.value,
                    modelYear: modelYear,
                    pledgeEndDate: pledgeEndDate,
                    pledgeStartDate: pledgeStartDate,
                    registrationDate: registrationDate,
                    rightsOwnerId: selectedRightsOwner?.value,
                    tcknVkn: tckn,
                    vehicleClassId: selectedVehicleClass?.value,
                    vehicleColorId: selectedVehicleColor?.value,
                    vehiclePassCards: vehiclePassCards.map(function (x) {
                        return {
                            cardName: x.cardName,
                            cardNo: x.cardNo,
                            isCustomActive: x.isCustomActive ? 1 : 0
                        }
                    }),
                    rentCompanyId: selectedRentCompany?.value,
                    rentCurrencyId: selectedRentCurrency?.value,
                    rentDescription: rentDesc,
                    rentEndDate: rentEndDate,
                    rentPriceMonthly: rentPriceMonthly,
                    rentStartDate: rentStartDate,
                    saleCompanyId: selectedSaleCompany?.value,
                    saleCurrencyId: selectedSaleCurrency?.value,
                    saleDescription: saleDesc,
                    salePrice: salePrice,
                    saleProxyEndDate: saleProxyEndDate,
                    saleProxyPersonName: saleProxyPersonName,
                    saleProxyStartDate: saleProxyStartDate,
                    saleTcknVkn: saleTcknVkn,
                    periodicalDocuments: periodicalDocuments.map(function (x) {
                        return {
                            additionalValue1: x.additionalValue1,
                            dateControl: x.dateControl ? 1 : 0,
                            documentNo: x.documentNo,
                            documentTypeId: x.documentTypeId,
                            endDate: x.endDate,
                            startDate: x.startDate,
                        }
                    }),
                    fileArchives: fileArchives.map(function (x) {
                        return {
                            description: x.description,
                            entityId: x.entityId,
                            file: x.fileArchiveFile,
                            fileName: x.fileName,
                            fileTypeId: x.fileTypeId,
                            fileArchiveId: x.fileArchiveId
                        }
                    })
                }

                var response: AddVehicleResponse = await VehicleService.addVehicle(obj);

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                toast.success(response.message)

                dispatch(storeActivityIndicator(false));
                navigate(Helpers.getGoBackUrl());
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    const getBrandAndBrandDetailFromInsuranceCode = async () => {
        try {
            if (Helpers.isEmpty(insuranceCode))
                return;

            dispatch(storeActivityIndicator(true))

            if (!Helpers.isEmpty(insuranceCode)) {
                var brandCode: string | undefined = undefined;
                var brandDetailCode: string | undefined = undefined;

                if (insuranceCode?.split('-').length == 1) {
                    brandCode = insuranceCode.split('-')[0].trim();
                }
                else {
                    brandCode = insuranceCode?.split('-')[0].trim();
                    brandDetailCode = insuranceCode?.split('-')[1].trim();
                }

                var response2: GetConstantListResponse = await ConstantService.getConstantList('VEHICLE_BRAND', undefined, brandCode);

                if (!response2.isSuccess) {
                    toast.error(response2.message)
                    return;
                }

                var brand = response2.data[0];

                if (brand && brandCode) {
                    setSelectedVehicleBrand({ label: brand.value, value: brand.constantId })

                    var response2: GetConstantListResponse = await ConstantService.getConstantList('VEHICLE_BRAND_DETAIL', brand.constantId);

                    if (!response2.isSuccess) {
                        toast.error(response2.message)
                        return;
                    }

                    var brandDetail = response2.data.find(x => x.additionalValue1 == brandDetailCode);

                    if (brandDetail && brandDetailCode) {
                        setSelectedVehicleBrandDetail({ label: brandDetail.value, value: brandDetail.constantId })
                    }
                    else {
                        setSelectedVehicleBrandDetail(undefined);
                    }
                }
                else {
                    setSelectedVehicleBrand(undefined);
                    setSelectedVehicleBrandDetail(undefined);
                }
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <PageHeader
                        items={[
                            { text: 'Genel Bilgiler', ref: generalInformationRef },
                            { text: 'Ruhsat Bilgileri', ref: licenseHolderRef },
                            { text: 'Teknik Bilgiler', ref: technicalInformationRef },
                            { text: 'Araç Geçiş Kartları', ref: passCardsRef },
                            { text: 'Süreli Belgeler', ref: periodicalDocumentsRef },
                            { text: 'Kiralama Bilgileri', ref: rentInformationRef },
                            { text: 'Satış Bilgileri', ref: saleInformationRef },
                            { text: 'Dijital Arşiv', ref: fileArchivesRef },
                        ]}
                    />

                    <GeneralInformation
                        b64={b64}
                        blockedDesc={blockedDesc}
                        fileRef={fileRef}
                        fuelConsumed={fuelConsumed}
                        fuelCapacity={fuelCapacity}
                        generalInformationRef={generalInformationRef}
                        setSelectedTrailer={setSelectedTrailer}
                        handleFileRead={handleFileRead}
                        isBlocked={isBlocked}
                        isCustomActive={isCustomActive}
                        plate={plate}
                        selectedDriver={selectedDriver}
                        selectedFuelType={selectedFuelType}
                        selectedVehicleArea={selectedVehicleArea}
                        selectedVehicleArea2={selectedVehicleArea2}
                        selectedTrailer={selectedTrailer}
                        selectedVehicleOwnerCompany={selectedVehicleOwnerCompany}
                        selectedVehicleProperties={selectedVehicleProperties}
                        selectedVehicleStatus={selectedVehicleStatus}
                        selectedVehicleType={selectedVehicleType}
                        selectedVehicleType2={selectedVehicleType2}
                        setB64={setB64}
                        setBlockedDesc={setBlockedDesc}
                        setFile={setFile}
                        setFuelConsumed={setFuelConsumed}
                        setFuelCapacity={setFuelCapacity}
                        hgsEtiketNo={hgsEtiketNo}
                        setHgsEtiketNo={setHgsEtiketNo}
                        uttsNo={uttsNo}
                        setUttsNo={setUttsNo}
                        setIsBlocked={setIsBlocked}
                        setIsCustomActive={setIsCustomActive}
                        setPlate={setPlate}
                        setSelectedDriver={setSelectedDriver}
                        setSelectedFuelType={setSelectedFuelType}
                        setSelectedVehicleArea={setSelectedVehicleArea}
                        setSelectedVehicleArea2={setSelectedVehicleArea2}
                        setSelectedVehicleOwnerCompany={setSelectedVehicleOwnerCompany}
                        setSelectedVehicleProperties={setSelectedVehicleProperties}
                        setSelectedVehicleStatus={setSelectedVehicleStatus}
                        setSelectedVehicleType={setSelectedVehicleType}
                        setSelectedVehicleType2={setSelectedVehicleType2}
                        vehicleTypeList2={vehicleTypeList2}
                    />

                    <LicenseHolder
                        chassisNumber={chassisNumber}
                        documentSerialNumber={documentSerialNumber}
                        engineNumber={engineNumber}
                        getBrandAndBrandDetailFromInsuranceCode={getBrandAndBrandDetailFromInsuranceCode}
                        handleFileRead={handleFileRead}
                        insuranceCode={insuranceCode}
                        isDeprivationOfRights={isDeprivationOfRights}
                        licenseB64={licenseB64}
                        licenseFileRef={licenseFileRef}
                        licenseHolderRef={licenseHolderRef}
                        modelYear={modelYear}
                        pledgeEndDate={pledgeEndDate}
                        pledgeStartDate={pledgeStartDate}
                        registrationDate={registrationDate}
                        selectedCounty={selectedCounty}
                        selectedDistrict={selectedDistrict}
                        selectedLicenseHolder={selectedLicenseHolder}
                        selectedRightsOwner={selectedRightsOwner}
                        selectedVehicleBrand={selectedVehicleBrand}
                        selectedVehicleBrandDetail={selectedVehicleBrandDetail}
                        selectedVehicleClass={selectedVehicleClass}
                        selectedVehicleColor={selectedVehicleColor}
                        setChassisNumber={setChassisNumber}
                        setDocumentSerialNumber={setDocumentSerialNumber}
                        setEngineNumber={setEngineNumber}
                        setInsuranceCode={setInsuranceCode}
                        setIsDeprivationOfRights={setIsDeprivationOfRights}
                        setLicenseB64={setLicenseB64}
                        setLicenseFile={setLicenseFile}
                        setModelYear={setModelYear}
                        setPledgeEndDate={setPledgeEndDate}
                        setPledgeStartDate={setPledgeStartDate}
                        setRegistrationDate={setRegistrationDate}
                        setSelectedCounty={setSelectedCounty}
                        setSelectedDistrict={setSelectedDistrict}
                        setSelectedLicenseHolder={setSelectedLicenseHolder}
                        setSelectedRightsOwner={setSelectedRightsOwner}
                        setSelectedVehicleBrand={setSelectedVehicleBrand}
                        setSelectedVehicleBrandDetail={setSelectedVehicleBrandDetail}
                        setSelectedVehicleClass={setSelectedVehicleClass}
                        setSelectedVehicleColor={setSelectedVehicleColor}
                        setTckn={setTckn}
                        tckn={tckn}
                        trCountry={trCountry}
                    />

                    <TechnicalInformation
                        aksCount={aksCount}
                        desi={desi}
                        gearboxType={gearboxType}
                        height={height}
                        height2={height2}
                        loadedWeight={loadedWeight}
                        netWeight={netWeight}
                        setAksCount={setAksCount}
                        setDesi={setDesi}
                        setGearboxType={setGearboxType}
                        setHeight={setHeight}
                        setHeight2={setHeight2}
                        setLoadedWeight={setLoadedWeight}
                        setNetWeight={setNetWeight}
                        setTacometerType={setTacometerType}
                        setVolume={setVolume}
                        setWidth={setWidth}
                        tacometerType={tacometerType}
                        technicalInformationRef={technicalInformationRef}
                        volume={volume}
                        width={width}
                    />

                    <PassCards
                        passCardsRef={passCardsRef}
                        setVehiclePassCards={setVehiclePassCards}
                        vehiclePassCards={vehiclePassCards}
                    />

                    <PeriodicalDocuments
                        periodicalDocuments={periodicalDocuments}
                        periodicalDocumentsRef={periodicalDocumentsRef}
                        setPeriodicalDocuments={setPeriodicalDocuments}
                    />

                    <Policeler vehicleId={vehicleId} />

                    <RentInformation
                        rentDesc={rentDesc}
                        rentEndDate={rentEndDate}
                        rentInformationRef={rentInformationRef}
                        rentPriceMonthly={rentPriceMonthly}
                        rentStartDate={rentStartDate}
                        selectedRentCompany={selectedRentCompany}
                        selectedRentCurrency={selectedRentCurrency}
                        setRentDesc={setRentDesc}
                        setRentEndDate={setRentEndDate}
                        setRentPriceMonthly={setRentPriceMonthly}
                        setRentStartDate={setRentStartDate}
                        setSelectedRentCompany={setSelectedRentCompany}
                        setSelectedRentCurrency={setSelectedRentCurrency}
                    />

                    <SaleInformation
                        saleDesc={saleDesc}
                        saleInformationRef={saleInformationRef}
                        salePrice={salePrice}
                        saleProxyEndDate={saleProxyEndDate}
                        saleProxyPersonName={saleProxyPersonName}
                        saleProxyStartDate={saleProxyStartDate}
                        saleTcknVkn={saleTcknVkn}
                        selectedSaleCompany={selectedSaleCompany}
                        selectedSaleCurrency={selectedSaleCurrency}
                        setSaleDesc={setSaleDesc}
                        setSalePrice={setSalePrice}
                        setSaleProxyEndDate={setSaleProxyEndDate}
                        setSaleProxyPersonName={setSaleProxyPersonName}
                        setSaleProxyStartDate={setSaleProxyStartDate}
                        setSaleTcknVkn={setSaleTcknVkn}
                        setSelectedSaleCompany={setSelectedSaleCompany}
                        setSelectedSaleCurrency={setSelectedSaleCurrency}
                    />

                    <FileArchives
                        fileArchives={fileArchives}
                        fileArchivesRef={fileArchivesRef}
                        setFileArchives={setFileArchives}
                    />

                    {
                        vehicleId && aracQr && (
                            <QrKarti
                                kartBasligi="Araç QR"
                                baslik={aracQr.plaka || plate}
                                qrMetni={aracQr.qrMetni}
                                qrKodu={aracQr.qrKodu}
                                onYenile={aracQrYenile}
                                aciklama="Etiketi yazdırıp araca yapıştırın; şoför okuttuğunda konum ve süre bilgi amaçlı kaydedilir. QR yenilenirse eski etiket çalışmaz."
                            />
                        )
                    }

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveVehicle}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default VehicleAdd;